import React, { useCallback, useMemo, useRef, useState } from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { useIntl } from "react-intl";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import ReportsConstants from "reports/utils/ReportsConstants";
import ReportsMessages from "reports/intl/ReportsMessages";
import useDownloadDataReport from "reports/data-export/data-export-list/hooks/useDownloadDataReport";

const { ACTIVATE, DEACTIVATE } = ReportsConstants;

const StBtnContainer = styled.div`
  display: flex;
  gap: 1rem;
`;

const StCounter = styled.div`
  font-weight: bold;
  padding: 0 2rem 0 1rem;
`;

const LeftContent = ({
  isSending,
  numSelected,
  selectedReports,
  toggleStatus,
}) => {
  const { formatMessage } = useIntl();
  const [clickedBtn, setClickedBtn] = useState("");
  const toastRef = useRef(null);
  const { isSending: isExporting, handleExport } = useDownloadDataReport(
    toastRef
  );

  const btnLabels = useMemo(() => {
    return {
      activate: formatMessage(ReportsMessages.activate).toUpperCase(),
      deactivate: formatMessage(ReportsMessages.deactivate).toUpperCase(),
      exportReport: formatMessage(ReportsMessages.exportReport).toUpperCase(),
    };
  }, [formatMessage]);

  const handleActivate = useCallback(() => {
    setClickedBtn(ACTIVATE);
    toggleStatus(ACTIVATE);
  }, [toggleStatus]);

  const handleDeactivate = useCallback(() => {
    setClickedBtn(DEACTIVATE);
    toggleStatus(DEACTIVATE);
  }, [toggleStatus]);

  const handleExportReport = useCallback(() => {
    handleExport(selectedReports);
  }, [handleExport, selectedReports]);

  return (
    <>
      <Toast ref={toastRef} />
      <StCounter>
        {formatMessage(ReportsMessages.numSelected, { numSelected })}
      </StCounter>
      <StBtnContainer>
        <Button
          disabled={isSending}
          label={btnLabels.activate}
          loading={isSending && clickedBtn === ACTIVATE}
          onClick={handleActivate}
        />
        <Button
          disabled={isSending}
          label={btnLabels.deactivate}
          loading={isSending && clickedBtn === DEACTIVATE}
          onClick={handleDeactivate}
        />
        <Button
          disabled={isExporting}
          label={btnLabels.exportReport}
          loading={isExporting}
          onClick={handleExportReport}
        />
      </StBtnContainer>
    </>
  );
};

LeftContent.propTypes = {
  isSending: PropTypes.bool,
  numSelected: PropTypes.number,
  selectedReports: PropTypes.arrayOf(PropTypes.shape({})),
  toggleStatus: PropTypes.func,
};

export default LeftContent;
